import Model from './BaseModel';
import Market from './Market';
import SportEvent from './SportEvent';

export default class SportSelection extends Model {
	resourceName() {
		return 'selections';
	}

	fields() {
		return [
			'comment',
			'key',
			'liabilities',
			'line',
			'name',
			'override_price',
			'participant_id',
			'price',
			'score',
			'status',
			'tradable',
			'type',
			'win',
			'payout_percentage',
			'bet_count'
		];
	}

	relationships() {
		return {
			market: new Market(),
			event: new SportEvent()
		};
	}

	computed() {
		return {
			display_price(selection) {
				return ((selection.override_price ? selection.override_price : selection.price) / 100).toFixed(2);
			},
			display_line(selection) {
				if (!selection.line) return null;
				return selection.line < 0 ? selection.line : `+${selection.line}`;
			}
		};
	}

	unresult() {
		return this.makePersistRequest({
			url: `${this.baseUrl()}/sport_selections/${this.id}/unfinalise`,
			method: 'POST'
		});
	}

	updateSelectionName(name) {
		return this.makePersistRequest({
			url: `${this.baseUrl()}/sport_selections/${this.id}`,
			method: 'PATCH',
			data: {
				name
			}
		});
	}
}
